import Model from '@/store/plugins/orm/Model'
import Money from '@/wrappers/Money';
import { BeginningInventoryItem } from './ModelRepository';
import i18n from '@/i18n';

export class BeginningInventory extends Model {
    static get entity () {
        return 'beginning_inventories'
    }

    static fields () {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            number: this.attr(null),
            date: this.attr(null),
            description: this.attr(null),
            recorded_at: this.attr(null),
            items: this.attr([], value => value.map(item => new BeginningInventoryItem(item))),
        }
    }

    getSellingValue() {
        return this.items.reduce((acc, cur) => acc.add(cur.getSellingValue()), Money.parse(0));
    }

    getTax() {
        return this.items.reduce((acc, cur) => acc.add(cur.getTax()), Money.parse(0));
    }

    getSellingValueAfterTax() {
        return this.items.reduce((acc, cur) => acc.add(cur.getSellingValueAfterTax()), Money.parse(0));
    }

    toTextLines() {
        const venue = this.$store().getters.tenant?.venue;
        if(!venue) return [];

        const lines = [];

        lines.push(`[HR]`);
        lines.push(`[C][H22]${i18n.t('beginning_inventories.heading')}`);
        lines.push(`[HR]`);
        lines.push(`[L]`);
        lines.push(`[L]${i18n.t('beginning_inventories.number')}: ${this.number}[R]${venue.name}`);
        lines.push(`[L]${i18n.t('beginning_inventories.date')}: ${moment(this.date).format('DD.MM.YYYY.')}[R]${i18n.t('general.tax_id_number')}: ${venue.tax_id_number}`);

        if(this.description) {
            lines.push(`[L]${i18n.t('beginning_inventories.description')}: ${this.description}`);
        }

        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);

        lines.push(`[HR]`);
        lines.push(
            `[L][H00]${i18n.t('general.number')}` +
            `[L]${i18n.t('general.code')}` +
            `[L]${i18n.t('general.inventory_item')}` +
            `[R]${i18n.t('beginning_inventories.quantity')}` +
            `[R]${i18n.t('beginning_inventories.selling_price')}` +
            `[R]${i18n.t('beginning_inventories.selling_price_after_tax')}` +
            `[R]${i18n.t('beginning_inventories.selling_value')}` +
            `[R]${i18n.t('beginning_inventories.tax')}` +
            `[R]${i18n.t('beginning_inventories.selling_value_after_tax')}`
        );
        lines.push(`[HR]`);

        this.items.forEach((item, index) => {
            lines.push(
                `[L][H00]${index + 1}` +
                `[L]${item.getProduct() && item.getProduct().code ? item.getProduct().code : ''}` +
                `[L]${item.getProduct() ? item.getProduct().name : ''}` +
                `[R]${item.getQuantity()} ${item.getUnitOfMeasure()}` +
                `[R]${item.getSellingPrice().toFormat('0.00')}` +
                `[R]${item.getSellingPriceAfterTax().toFormat('0.00')}` +
                `[R]${item.getSellingValue().toFormat('0.00')}` +
                `[R]${item.getTax().toFormat('0.00')} (${item.getTaxRate()}%)` +
                `[R]${item.getSellingValueAfterTax().toFormat('0.00')}`
            );
        })

        lines.push(`[HR]`);

        lines.push(
            `[L][H00][L][L][L][L]` +
            `[R]${i18n.t('general.total').toUpperCase()}:` +
            `[R]${this.getSellingValue().toFormat('0.00')}` +
            `[R]${this.getTax().toFormat('0.00')}` +
            `[R]${this.getSellingValueAfterTax().toFormat('0.00')}`
        );

        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);

        lines.push(`[L][C]${i18n.t('general.created_by')}[L][C]${i18n.t('general.received_by')}[L][C]${i18n.t('general.responsible_person')}[L]`);
        lines.push(`[L]`);
        lines.push(`[L][C]________________[L][C]________________[L][C]_________________[L]`);

        return lines;
    }
}

export default BeginningInventory
